module.exports = __webpack_public_path__ + "img/visa.513ff24.png";